import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  AutoComplete,
  Col,
  Input,
  Row,
  // Typography,
  // Skeleton,
} from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import "./index.css";
// import { emailIsValid } from "../Auth/validations";
import { PiUserSoundFill } from "react-icons/pi";
// import { isEmpty } from "lodash";
import { faqMenus, invoiceTypeList, shortcutList } from "./data";
import { BiChat, BiLogoWhatsapp, BiPhone } from "react-icons/bi";

const HelpSupport = (props) => {
  //State data section
  const [helpMode, setHelpMode] = useState("Invoices");
  const [options, setOptions] = useState([]);
  // const [searchSelected, setSearchSelected] = useState("");
  const mockVal = (str, repeat = 1) => ({
    value: str.repeat(repeat),
  });

  //Search parties
  const getPanelValue = (searchText) =>
    !searchText ? [] : [mockVal(searchText)];
  
  console.log(options, "options");
  const searchList = invoiceTypeList.concat(shortcutList);

  const searchOptions =
    searchList.length > 0
      ? searchList.map((data) => {
          return {
            value: data.label,
            label: data.label,
            type: data.type,
          };
        })
      : [];

      const onSelect = (data) => {
        console.log("onSelect", data);
        const searchSelectedData = data
        ? searchOptions.find((search) => search.label === data)
        : "";
        // setSearchSelected(data);
        setHelpMode(searchSelectedData.type)
      };
    

  console.log(searchOptions, "searchOptions");
  //Invoice section
  const [invoiceTag, setInvoiceTag] = useState("");
  const [shortcutTag, setShortcutTag] = useState("");

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Account | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-md bg-[#ffffff] pb-10">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24}>
          <Row className="flex justify-between pl-[10px] pr-[10px] mt-4">
            <Col span={12} className="flex">
              <div className="ml-2 account-sub-header">
                <h1 className="text-[18px] mb-[1px] mt-2 font-semibold leading-tight">
                  Help and Support
                </h1>
                <p className="text-[12.5px]">
                  Find answers for all your doubts
                </p>
              </div>
            </Col>
            <Col span={12}>
              <AutoComplete
                options={searchOptions}
                style={{
                  width: "100%",
                  marginRight: "10px",
                  marginTop: "10px",
                }}
                onSelect={onSelect}
                onSearch={(text) => setOptions(getPanelValue(text))}
              >
                <Input.Search size="large" placeholder="Search" />
              </AutoComplete>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row className="w-[100%] border border-x-0 border-t-1 border-b-0 mt-3"></Row>
        </Col>
        <Col span={24}>
          <Row className="">
            <Col span={6} className="h-[450px] border border-r-1">
              <div className="w-[100%] bg-[#e9ecf1] text-[#28313b] border p-4 pl-4 pr-4 text-[13px] account-sub-header border-x-0 border-b-1 border-t-0">
                FAQS
              </div>
              {faqMenus.map((data, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                     
                        setHelpMode(data.label);
                      
                    }}
                    className={
                      helpMode === data.label
                        ? "w-[100%] cursor-pointer bg-[#d2cdf5] text-[#28313b] p-4 pl-4 pr-4 border text-[13px] account-sub-header border-x-0 border-b-1 border-t-0"
                        : "w-[100%] cursor-pointer text-[#28313b] p-4 pl-4 pr-4 border text-[13px] account-sub-header border-x-0 border-b-1 border-t-0"
                    }
                  >
                    {data.label}
                  </div>
                );
              })}
            </Col>
            <Col span={18}>
              {helpMode === "Shortcuts" ? (
                <Row className="p-4 h-[315px]">
                  <Col span={24}>
                    {shortcutList.map((data, index) => {
                      return (
                        <div>
                          <Row
                            key={index}
                            onClick={() => {
                              if (shortcutTag === data.label) {
                                setShortcutTag("");
                              } else {
                                setShortcutTag(data.label);
                              }
                            }}
                            className="cursor-pointer w-[100%] flex justify-between bg-gray-100 p-3 pl-5 pr-5 mb-3"
                          >
                            <h1 className="flex text-[11px] account-sub-header font-medium">
                              <p className="font-medium text-[13px] mr-2">
                                {data.label}
                              </p>{" "}
                            </h1>
                            {shortcutTag === data.label ? (
                              <MinusOutlined
                                className="text-[blue] font-semibold text-[18px]"
                                onClick={() => {
                                  setShortcutTag("");
                                }}
                              />
                            ) : (
                              <PlusOutlined
                                className="text-[blue] font-semibold text-[18px]"
                                onClick={() => {
                                  setShortcutTag(data.label);
                                }}
                              />
                            )}
                          </Row>
                          {data.label === shortcutTag && (
                            <Row className="pl-4 pr-4 mb-2">
                              <Col span={24} className="pr-4">
                                <div className="">
                                  <div>
                                    <h1 className="account-sub-header text-[13px] mb-[1px] mt-2 font-normal leading-tight">
                                      {data.text}
                                    </h1>
                                    <p className=" account-sub-header text-[13px] mt-4 mb-2">
                                      {data.subText}
                                    </p>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </div>
                      );
                    })}
                  </Col>
                </Row>
              ) : (
                <Row className="p-4 h-[315px]">
                  <Col span={24}>
                    {invoiceTypeList.map((data, index) => {
                      return (
                        <div>
                          <Row
                            key={index}
                            onClick={() => {
                              if (invoiceTag === data.label) {
                                setInvoiceTag("");
                              } else {
                                setInvoiceTag(data.label);
                              }
                            }}
                            className="cursor-pointer w-[100%] flex justify-between bg-gray-100 p-3 pl-5 pr-5 mb-3"
                          >
                            <h1 className="flex text-[11px]  account-sub-header font-medium">
                              <p className="font-medium text-[13px] mr-2">
                                {data.label}
                              </p>{" "}
                            </h1>
                            {invoiceTag === data.label ? (
                              <MinusOutlined
                                className="text-[blue] font-semibold text-[18px]"
                                onClick={() => {
                                  setInvoiceTag("");
                                }}
                              />
                            ) : (
                              <PlusOutlined
                                className="text-[blue] font-semibold text-[18px]"
                                onClick={() => {
                                  setInvoiceTag(data.label);
                                }}
                              />
                            )}
                          </Row>
                          {data.label === invoiceTag && (
                            <Row className="pl-4 pr-4 mb-2">
                              <Col span={24} className="pr-4">
                                <div className="">
                                  <div>
                                    <h1 className="account-sub-header text-[13px] mb-[1px] mt-2 font-normal leading-tight">
                                      {data.text}
                                    </h1>
                                    <p className="account-sub-header text-[13px] mt-4 mb-2">
                                      {data.subText}
                                    </p>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </div>
                      );
                    })}
                  </Col>
                </Row>
              )}
              <Row>
                <div className="ml-3">
                  <h1 className="text-[#4c3cce]">Need help? contact support</h1>
                </div>
                <Col span={24}>
                  <Row className="w-[100%] border border-x-0 border-t-1 border-b-0 mt-1">
                    <Col
                      span={6}
                      className="flex justify-center border border-r-1 p-2"
                    >
                      <div className="flex mt-1">
                        <BiPhone className="mt-1 text-[gray]" size={30} />
                        <div className="ml-2">
                          <h2>Call us</h2>
                          <p>7411334343</p>
                        </div>
                      </div>
                    </Col>
                    <Col
                      span={6}
                      className="flex justify-center border border-r-1 p-2"
                    >
                      <div className="flex mt-1">
                        <BiLogoWhatsapp
                          className="mt-1 text-[gray]"
                          size={30}
                        />
                        <div className="ml-2">
                          <h2>WhatsApp us</h2>
                          <p>7411334343</p>
                        </div>
                      </div>
                    </Col>
                    <Col
                      span={6}
                      className="flex justify-center border border-r-1 p-2"
                    >
                      <div className="flex mt-1">
                        <BiChat className="mt-1 text-[gray]" size={30} />
                        <div className="ml-2 mt-2">
                          <h2>Live Chat</h2>
                        </div>
                      </div>
                    </Col>
                    <Col
                      span={6}
                      className="flex justify-center border border-r-1 p-2"
                    >
                      <div className="flex mt-1">
                        <PiUserSoundFill className="text-[30px] mt-1 mr-2" />
                        <div className="ml-2 mt-2">
                          <h2>Share Suggestion</h2>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </React.Fragment>
  );
};
HelpSupport.propTypes = {
  location: PropTypes.any,
};

export default HelpSupport;
